module.exports = __webpack_public_path__ + "img/contact-icon-3.46fa6282.png";